import React from "react"
import InlineMultiSelectDropdown from "../../molecules/InlineMultiSelectDropdown.molecule"

const categoryFilterTemplate = ({
  options,
  categories = /** @type {import("../../../utils/report.utils").FormattedCategory[]} */ ([]),
  filterConfig,
  categoryFilterOptionsRef,
  loading,
}) => {
  const filterFields = filterConfig?.filterFields?.split(",")
  const filterValues = filterConfig?.filterValues?.split(",")
  let savedCategories = null
  if (filterFields?.includes("categoryId")) {
    savedCategories = filterValues?.filter(
      (value, index) => filterFields[index] === "categoryId"
    )
  }
  if (!options.value && savedCategories) {
    options.value = savedCategories
  }
  categoryFilterOptionsRef.current = options
  return (
    <InlineMultiSelectDropdown
      value={options.value ?? []}
      options={categories}
      optionLabel="label"
      optionValue="value"
      onChange={(value) => {
        options.filterCallback(value)
      }}
      hasSearchBar
      hideToggleButton
      initiallyExpanded
      emptyFilterMessage="Misión fallida... no encontramos nada"
      placeholder="Filtrar categoría"
      itemTemplate={(option) => {
        return option.label
      }}
      selectedItemTemplate={(option) => {
        return categories.find((c) => c.value === option)?.label
      }}
      maxSelectedLabels={1}
      selectedItemsLabel={`${options.value?.length} seleccionados`}
      disabled={categories.length === 0}
      loading={loading}
    />
  )
}

export default categoryFilterTemplate
